function Facebook() {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.5 12.0733C24.5 5.40546 19.1274 0 12.5 0C5.87262 0 0.5 5.40536 0.5 12.0733C0.5 18.0994 4.88825 23.0943 10.625 24V15.5633H7.57812V12.0733H10.625V9.41343C10.625 6.38755 12.4166 4.71615 15.1575 4.71615C16.4705 4.71615 17.8438 4.95195 17.8438 4.95195V7.92313H16.3306C14.8398 7.92313 14.375 8.85381 14.375 9.80864V12.0733H17.7031L17.1711 15.5633H14.375V24C20.1117 23.0943 24.5 18.0995 24.5 12.0733Z"
        fill="#4C76BE"
        className="fill"
      />
    </svg>
  );
}

export default Facebook;
